import React from 'react';
import { Spinner } from 'react-bootstrap';
import { C } from '../utils/constants';
import { fmtUnit } from '../utils/helpers';
import InfoTip from './InfoTip';

// unit : respecte le sélecteur d'unité de la section parente (montants uniquement)

const ComboKpiCard = ({ icon, budgetLabel, budgetInfo, budgetValue, realLabel, realInfo, realValue, pct: pctVal, details, loading, color, onCardClick, onBudgetClick, active, unit }) => {
  const pctColor = pctVal == null ? '#999' : pctVal >= 100 ? C.green : pctVal >= 70 ? C.amber : '#c62828';
  const r2 = 20, circ2 = 2 * Math.PI * r2;
  const dash2 = (Math.min(Math.max(pctVal || 0, 0), 100) / 100) * circ2;

  return (
    <div style={{
      background: '#fff', borderRadius: 10,
      border: `1px solid ${active ? color : C.border}`,
      borderTop: `4px solid ${color}`, flex: '1 1 260px', minWidth: 0,
      overflow: 'hidden', position: 'relative',
      boxShadow: active ? `0 0 0 2px ${color}33` : 'none',
      transition: 'box-shadow 0.15s, border-color 0.15s',
    }}>
      <div style={{ position: 'absolute', right: 10, top: 8, color, opacity: 0.07, fontSize: '3.5rem', pointerEvents: 'none' }}>
        {icon}
      </div>

      <div onClick={onBudgetClick} style={{ padding: '12px 16px 6px', cursor: onBudgetClick ? 'pointer' : 'default' }}
        title={onBudgetClick ? 'Voir le détail budget' : undefined}>
        <div style={{ fontSize: '0.65rem', fontWeight: 700, color: '#bbb', textTransform: 'uppercase', letterSpacing: 1, display: 'flex', alignItems: 'center' }}>
          {budgetLabel}<InfoTip text={budgetInfo} />
        </div>
        {loading
          ? <div style={{ height: 22 }}><Spinner size="sm" /></div>
          : <div style={{ fontSize: '1.1rem', fontWeight: 700, color: onBudgetClick ? '#888' : '#aaa', lineHeight: 1.2, textDecoration: onBudgetClick ? 'underline dotted #bbb' : 'none' }}>{fmtUnit(budgetValue, unit)}</div>
        }
      </div>

      <div onClick={onCardClick} style={{ padding: '6px 16px 12px', cursor: onCardClick ? 'pointer' : 'default' }}
        title={onCardClick ? 'Voir le détail' : undefined}>
        <div style={{ borderTop: `1px solid ${C.border}`, marginBottom: '8px' }} />
        <div style={{ fontSize: '0.65rem', fontWeight: 700, color: '#999', textTransform: 'uppercase', letterSpacing: 1, display: 'flex', alignItems: 'center' }}>
          {realLabel}<InfoTip text={realInfo} />
        </div>
        {loading
          ? <div style={{ height: 54 }}><Spinner size="sm" /></div>
          : <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8 }}>
              <div style={{ fontSize: '1.55rem', fontWeight: 700, color: C.primary, lineHeight: 1.15 }}>{fmtUnit(realValue, unit)}</div>
              <svg width="54" height="54" viewBox="0 0 50 50" style={{ flexShrink: 0 }}>
                <circle cx="25" cy="25" r={r2} fill="none" stroke="#f0ebe4" strokeWidth="6" />
                {pctVal != null && (
                  <circle cx="25" cy="25" r={r2} fill="none" stroke={color} strokeWidth="6"
                    strokeDasharray={`${dash2} ${circ2 - dash2}`} strokeLinecap="round"
                    transform="rotate(-90 25 25)" style={{ transition: 'stroke-dasharray 0.6s ease' }} />
                )}
                <text x="25" y="25" textAnchor="middle" dominantBaseline="middle" fontSize="9" fontWeight="800" fill={pctColor}>
                  {pctVal != null ? `${Math.round(pctVal)}%` : '—'}
                </text>
              </svg>
            </div>
        }
      </div>

      {details?.length > 0 && (
        <div style={{ borderTop: `1px solid ${C.border}`, padding: '6px 16px', background: '#fdfaf7' }}>
          {details.map(({ label, info, value, color: dc, onClick: rowClick, activeRow, badge }) => (
            <div key={label} onClick={rowClick}
              style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '3px 4px', borderRadius: 4, margin: '1px -4px', cursor: rowClick ? 'pointer' : 'default', background: activeRow ? `${dc || color}18` : 'transparent', transition: 'background 0.12s' }}
              onMouseEnter={e => { if (rowClick) e.currentTarget.style.background = `${dc || color}18`; }}
              onMouseLeave={e => { e.currentTarget.style.background = activeRow ? `${dc || color}18` : 'transparent'; }}>
              <span style={{ fontSize: '0.7rem', color: '#888', display: 'flex', alignItems: 'center', gap: 4 }}>
                {label}<InfoTip text={info} />
                {badge && <span style={{ fontSize: '0.63rem', fontWeight: 700, color: badge.color, background: `${badge.color}1a`, padding: '1px 6px', borderRadius: 8, border: `1px solid ${badge.color}44` }}>{badge.text}</span>}
              </span>
              <span style={{ fontSize: '0.75rem', fontWeight: 600, color: dc || C.primary }}>
                {loading ? <Spinner size="sm" /> : value}
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ComboKpiCard;
